/* src/app/agent-builder/agent-builder-kb-upload/agent-builder-kb-upload.component.scss */
:host {
  display: block;
  padding: 12px 0;
}
nz-upload {
  margin-bottom: 12px;
}
button {
  margin-top: 8px;
}
.uploading {
  opacity: 0.6;
  pointer-events: none;
}
.kb-upload-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}
.kb-list-container {
  flex: 1;
  height: calc(100vh - 400px);
  min-height: 0;
  overflow: auto;
  flex-direction: column;
}
/*# sourceMappingURL=agent-builder-kb-upload.component.css.map */
